let handler: (() => void) | null = null;

/** The app layer registers what "session is gone" means (clear caches, go to /login). */
export function setSessionExpiredHandler(fn: (() => void) | null) {
  handler = fn;
}

export function notifySessionExpired() {
  handler?.();
}
